import { isHotel } from 'lib/offer/offerTypes'
import { useAppSelector } from 'hooks/reduxHooks'
import { getAllOffers } from 'selectors/offerSelectors'

export default function useOffersWithProperty(
  offerIds: Array<string>,
  targetPropertyId: string | undefined,
): App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary | undefined {
  const allOffers = useAppSelector(getAllOffers)

  if (!targetPropertyId) return

  /**
   * The array check here is just a band-aid.
   * The actual problem is the wrongly typed `qs.parse` in `function parseSearchString at `src/client/lib/url/searchUrlUtils.ts:52`
   * ```ts
   * const queryResult = qs.parse(searchString, { ignoreQueryPrefix: true }) as { [key: string]: string }
   * ```
   */
  const formattedPropertyId = (Array.isArray(targetPropertyId) ? (targetPropertyId[0] as string) : targetPropertyId).split(':')[1]

  for (const offerId of offerIds) {
    const offer: App.AnyOffer = allOffers[offerId]
    if (offer && isHotel(offer) && offer.property.id === formattedPropertyId) {
      return offer
    }
  }
}
